import * as React from 'react';
import commonStrings from 'owa-strings/owa-common-strings';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { Dialog, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import PolicyTipsViewState from '../store/schema/PolicyTipsViewState';
import setIsFalsePositive from '../actions/setIsFalsePositive';
import setOverrideJustification from '../actions/setOverrideJustification';

export interface PolicyTipsOverrideDialogProps {
    onClose?: () => void;
    viewState: PolicyTipsViewState;
}

export interface PolicyTipsOverrideDialogState {
    isShown: boolean;
    isFalsePositive: boolean;
    errorMessage: string;
    justification: string;
}

export default class PolicyTipsOverrideDialog extends React.Component<
    PolicyTipsOverrideDialogProps,
    PolicyTipsOverrideDialogState
> {
    constructor(props: PolicyTipsOverrideDialogProps) {
        super(props);
        this.state = {
            isShown: true,
            isFalsePositive: false,
            errorMessage: null,
            justification: null,
        };
    }

    private onAcceptChanges = () => {
        if (this.state.isFalsePositive) {
            setIsFalsePositive(this.props.viewState, true);
            this.onDismiss();
        } else if (this.state.justification && this.state.justification.length > 0) {
            setOverrideJustification(this.props.viewState, this.state.justification);
            this.onDismiss();
        } else {
            this.setState({
                errorMessage: commonStrings.policyTipsOverrideJustificationErrorMessage,
            });
        }
    };

    private onDismiss = () => {
        this.setState({
            isShown: false,
        });
        this.props.onClose();
    };

    private onSelectionChange = (ev, option) => {
        this.setState({
            isFalsePositive: option.key == 'FalsePositive',
        });
    };

    private onJustificationChange = (ev, value) => {
        this.setState({
            justification: value,
            errorMessage: null,
        });
    };

    render() {
        return (
            <Dialog
                hidden={!this.state.isShown}
                onDismiss={this.onDismiss}
                subText={commonStrings.policyTipsOverrideJustificationDescription}>
                <ChoiceGroup
                    defaultSelectedKey="Override"
                    onChange={this.onSelectionChange}
                    options={[
                        {
                            key: 'Override',
                            text:
                                commonStrings.policyTipsOverrideJustificationRadioButtonReasonLabel,
                            onRenderField: (props, render) => {
                                return (
                                    <div>
                                        {render(props)}
                                        <TextField
                                            onChange={this.onJustificationChange}
                                            errorMessage={this.state.errorMessage}
                                            placeholder={
                                                commonStrings.policyTipsOverrideJustificationReasonTextboxPlaceholder
                                            }
                                        />
                                    </div>
                                );
                            },
                        },
                        {
                            key: 'FalsePositive',
                            text:
                                commonStrings.policyTipsOverrideJustificationRadioButtonFalsePositiveLabel,
                        },
                    ]}
                />
                <DialogFooter>
                    <PrimaryButton onClick={this.onAcceptChanges}>
                        {commonStrings.policyTipsOverrideLink}
                    </PrimaryButton>
                    <DefaultButton onClick={this.onDismiss}>
                        {commonStrings.cancelButton}
                    </DefaultButton>
                    }
                </DialogFooter>
            </Dialog>
        );
    }
}
